import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  href,
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-xl border-b-4 border-dorado-dark bg-dorado px-4 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-azul shadow-[0_0_0_3px_rgb(var(--dorado)/0.25)] transition-[background-color,transform] duration-150 ease-soft hover:bg-dorado-dark hover:text-blanco active:translate-y-px active:scale-[0.99] sm:text-lg ${className}`} data-id="element-159" data-mp="1vvhde7s5cuuj">
      {children}
    </a>;
}